<form [formGroup]="realEstateForm" class="real-estate-form">
  <div class="form-section">
    <div class="form-grid">
      <div class="form-group">
        <span class="group-label required"
          >Are you looking to rent or buy a commercial site or facility?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="rentBuyYes"
              type="radio"
              formControlName="lookingToRentOrBuy"
              value="yes"
            />
            <label for="rentBuyYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="rentBuyNo"
              type="radio"
              formControlName="lookingToRentOrBuy"
              value="no"
            />
            <label for="rentBuyNo">No</label>
          </div>
          <div class="radio-item">
            <input
              id="rentBuyUnsure"
              type="radio"
              formControlName="lookingToRentOrBuy"
              value="unsure"
            />
            <label for="rentBuyUnsure">Unsure</label>
          </div>
        </div>
        @if (
          realEstateForm.get("lookingToRentOrBuy")?.touched &&
          realEstateForm.get("lookingToRentOrBuy")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      <div class="form-group">
        <span class="group-label required"
          >Are you looking to upgrade a commercial facility you do business
          from?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="upgradeYes"
              type="radio"
              formControlName="lookingToUpgrade"
              [value]="true"
            />
            <label for="upgradeYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="upgradeNo"
              type="radio"
              formControlName="lookingToUpgrade"
              [value]="false"
            />
            <label for="upgradeNo">No</label>
          </div>
        </div>
        @if (
          realEstateForm.get("lookingToUpgrade")?.touched &&
          realEstateForm.get("lookingToUpgrade")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>

      @if (realEstateForm.get("lookingToUpgrade")?.value === true) {
        <div class="form-group indent">
          <span class="group-label required">Do you own your facility?</span>
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="ownYes"
                type="radio"
                formControlName="ownFacility"
                [value]="true"
              />
              <label for="ownYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="ownNo"
                type="radio"
                formControlName="ownFacility"
                [value]="false"
              />
              <label for="ownNo">No</label>
            </div>
          </div>
          @if (
            realEstateForm.get("ownFacility")?.touched &&
            realEstateForm.get("ownFacility")?.invalid
          ) {
            <span class="error-message">This field is required</span>
          }
        </div>
      }

      @if (realEstateForm.get("ownFacility")?.value === false) {
        <div class="form-group indent-more">
          <span class="group-label required"
            >Is your building owner willing to support upgrades?</span
          >
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="ownerSupportYes"
                type="radio"
                formControlName="buildingOwnerWillingToSupport"
                value="yes"
              />
              <label for="ownerSupportYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="ownerSupportNo"
                type="radio"
                formControlName="buildingOwnerWillingToSupport"
                value="no"
              />
              <label for="ownerSupportNo">No</label>
            </div>
            <div class="radio-item">
              <input
                id="ownerSupportNeedHelp"
                type="radio"
                formControlName="buildingOwnerWillingToSupport"
                value="need_support"
              />
              <label for="ownerSupportNeedHelp"
                >I need support in approaching this topic</label
              >
            </div>
          </div>
          @if (
            realEstateForm.get("buildingOwnerWillingToSupport")?.touched &&
            realEstateForm.get("buildingOwnerWillingToSupport")?.invalid
          ) {
            <span class="error-message">This field is required</span>
          }
        </div>
      }

      <div class="form-group">
        <span class="group-label required"
          >Are you interested in energy-efficient upgrades or adding solar to
          your facility?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="energyYes"
              type="radio"
              formControlName="interestedInEnergyUpgrades"
              [value]="true"
            />
            <label for="energyYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="energyNo"
              type="radio"
              formControlName="interestedInEnergyUpgrades"
              [value]="false"
            />
            <label for="energyNo">No</label>
          </div>
        </div>
        @if (
          realEstateForm.get("interestedInEnergyUpgrades")?.touched &&
          realEstateForm.get("interestedInEnergyUpgrades")?.invalid
        ) {
          <span class="error-message">This field is required</span>
        }
      </div>
    </div>
  </div>
</form>
